import { parsePhoneNumberFromString } from 'libphonenumber-js';
import currency from "currency.js";

export function formatCurrencyNew(value, currencySymbol, precision = 2) {
  return currency(value, {
    symbol: currencySymbol,
    precision: precision,
    separator: ',',
    decimal: '.',
  }).format();
}


export function isValidInternationalPhoneNumber(phoneNumber) {
  if (typeof phoneNumber !== 'string' || phoneNumber.trim() === '') {
    return false;
  }
  const phoneNumberObj = parsePhoneNumberFromString(phoneNumber);
  // console.log("phonenumberObj", phoneNumberObj.isValid(),phoneNumber);
  return phoneNumberObj ? phoneNumberObj.isValid() : false;
}



//  const webDetails = useSelector(state => state.webDetails);
//     const { websiteInfo } = webDetails;


// for store offline or online 
//  const webDetails = useSelector(state => state.webDetails);
//     const { websiteInfo } = webDetails;
//     websiteInfo?.whatsapp_status